'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createBrowserHistory');
module.exports = require('./index.js').createBrowserHistory;



//////////////////
// WEBPACK FOOTER
// ./~/history/createBrowserHistory.js
// module id = 757
// module chunks = 168707334958949